import React from "react";

// Stroke-based line icon (boom sprayer) so it colours with the sidebar's white
// icon treatment like the rest of the nav — the old version hard-coded #8F9497.
const Spray = () => {
  return (
    <div className="sidebar-icon">
      <svg
        className="sidebar-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 6H18C18.55 6 19 6.45 19 7V9C19 9.55 18.55 10 18 10H3V6Z"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
        <path
          d="M19 8H21.5"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
        <path
          d="M6 10.5L5 13M10.5 10.5L9.5 13M15 10.5L14 13"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
        <path
          d="M6 15L5.4 16.5M10.5 15L9.9 16.5M15 15L14.4 16.5"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
      </svg>
    </div>
  );
};

export default Spray;
